module.exports = __webpack_public_path__ + "static/media/ecommerce_bg.ce6c1168.png";